import Col from 'react-bootstrap/Col';
import React from 'react';
import Image from 'next/image';
import IDEAL from '@images/footer/IDEAL.svg';
import VISA from '@images/footer/VISA.svg';
import MasterCard from '@images/footer/MasterCard.svg';
import Maestro from '@images/footer/Maestro.svg';
import PayPal from '@images/footer/PayPal.svg';
import Belfius from '@images/footer/Belfius.svg';
import KBC from '@images/footer/KBC.svg';
import DirectBank from '@images/footer/DirectBank.svg';
import { ILinkList } from '@/services/template-data-service';

export default function DisclaimerFooter({ links }: { links: ILinkList }) {
  const paymentIcons = [
    { icon: IDEAL, width: 28, height: 24 },
    { icon: VISA, width: 38, height: 24 },
    { icon: MasterCard, width: 40, height: 24 },
    { icon: Maestro, width: 38, height: 24 },
    { icon: PayPal, width: 20, height: 24 },
    { icon: Belfius, width: 24, height: 24 },
    { icon: KBC, width: 24, height: 24 },
    { icon: DirectBank, width: 32, height: 17 }
  ];

  return (
    <>
      <Col lg={9} xl={8}>
        <h3>{links.title}</h3>
        <ul>
          {links.items.map((item, idx) => (
            <li key={idx}>
              <a href={item.href}>{item.text}</a>
            </li>
          ))}
        </ul>
      </Col>
      <Col className="mt-3" lg={3} xl={4}>
        {paymentIcons.map((icon, i) => (
          <a className="pl-2" key={i} href="/klantenservice/betalen" target="_blank" rel="noopener noreferrer">
            <Image src={icon.icon} alt="Betalen" width={icon.width} height={icon.height} />
          </a>
        ))}
      </Col>
    </>
  );
}
